module.exports = __webpack_public_path__ + "static/media/nutrition.d5e34075.png";